export const RESOURCES = {
  TELEMETRIA: 'TELEMETRIA',
  GERENCIAR_ASSINATURA: 'GERENCIAR_ASSINATURA',
  GERENCIAR_ARQUIVOS: 'GERENCIAR_ARQUIVOS',
  NOTIFICACOES_PUSH: 'NOTIFICACOES_PUSH',
  // Criar, publicar e acompanhar comunicados à equipe
  PUBLICAR_COMUNICADOS: 'PUBLICAR_COMUNICADOS',
  // Válvula de suporte dos documentos fiscais: alterar situação na mão, fora do fluxo da SEFAZ
  VALVULA_DE_SUPORTE: 'VALVULA_DE_SUPORTE',

  // Dashboard
  DASHBOARD_VENDAS_INDICADORES: 'DASHBOARD_VENDAS_INDICADORES',
  DASHBOARD_VENDAS_TABELA_VENDAS_POR_PRODUTO: 'DASHBOARD_VENDAS_TABELA_VENDAS_POR_PRODUTO',
  DASHBOARD_VENDAS_GRAFICO_VENDAS: 'DASHBOARD_VENDAS_GRAFICO_VENDAS',
  DASHBOARD_VENDAS_GRAFICO_TICKET_MEDIO: 'DASHBOARD_VENDAS_GRAFICO_TICKET_MEDIO',
  DASHBOARD_VENDAS_GRAFICO_CATEGORIAS_MAIS_VENDIDAS: 'DASHBOARD_VENDAS_GRAFICO_CATEGORIAS_MAIS_VENDIDAS',
  DASHBOARD_VENDAS_GRAFICO_HORARIOS_MAIS_VENDAS: 'DASHBOARD_VENDAS_GRAFICO_HORARIOS_MAIS_VENDAS',
  DASHBOARD_VENDAS_GRAFICO_METODOS_DE_PAGAMENTO: 'DASHBOARD_VENDAS_GRAFICO_METODOS_DE_PAGAMENTO',

  // Dashboard Financeiro
  DASHBOARD_FINANCEIRO_GRAFICO_FLUXO_CAIXA: 'DASHBOARD_FINANCEIRO_GRAFICO_FLUXO_CAIXA',
  DASHBOARD_FINANCEIRO_INDICADORES: 'DASHBOARD_FINANCEIRO_INDICADORES',
  DASHBOARD_FINANCEIRO_GRAFICO_METODOS_DE_PAGAMENTO: 'DASHBOARD_FINANCEIRO_GRAFICO_METODOS_DE_PAGAMENTO',

  // Dashboard Operacional
  DASHBOARD_OPERACIONAL_INDICADORES: 'DASHBOARD_OPERACIONAL_INDICADORES',
  DASHBOARD_OPERACIONAL_TABELA_PRODUTOS_VENCIMENTO_PROXIMO: 'DASHBOARD_OPERACIONAL_TABELA_PRODUTOS_VENCIMENTO_PROXIMO',
  DASHBOARD_OPERACIONAL_TABELA_ULTIMAS_OPERACOES_ESTOQUE: 'DASHBOARD_OPERACIONAL_TABELA_ULTIMAS_OPERACOES_ESTOQUE',
  DASHBOARD_OPERACIONAL_TABELA_PERDAS_ESTOQUE: 'DASHBOARD_OPERACIONAL_TABELA_PERDAS_ESTOQUE',

  // Catálogo
  CATALOGO_CATEGORIAS: 'CATALOGO_CATEGORIAS',
  CATALOGO_PRODUTOS: 'CATALOGO_PRODUTOS',
  CATALOGO_LISTAS_DE_PRECO: 'CATALOGO_LISTAS_DE_PRECO',

  // Cadastros
  CADASTROS_CONDOMINIOS: 'CADASTROS_CONDOMINIOS',
  CADASTROS_FORNECEDORES: 'CADASTROS_FORNECEDORES',
  CADASTROS_PONTOS_DE_VENDA: 'CADASTROS_PONTOS_DE_VENDA',
  CADASTROS_CLIENTES: 'CADASTROS_CLIENTES',
  CADASTROS_FUNCIONARIOS: 'CADASTROS_FUNCIONARIOS',
  CADASTROS_TERMINAIS: 'CADASTROS_TERMINAIS',

  // Suprimentos
  SUPRIMENTOS_ESTOQUE: 'SUPRIMENTOS_ESTOQUE',
  SUPRIMENTOS_ORDEMS_DE_COMPRA: 'SUPRIMENTOS_ORDEMS_DE_COMPRA',
  SUPRIMENTOS_PICKING: 'SUPRIMENTOS_PICKING',
  SUPRIMENTOS_NOTAS_FISCAIS_DE_ENTRADA: 'SUPRIMENTOS_NOTAS_FISCAIS_DE_ENTRADA',
  SUPRIMENTOS_INVENTARIO: 'SUPRIMENTOS_INVENTARIO',
  SUPRIMENTOS_AJUSTES_DE_ESTOQUE: 'SUPRIMENTOS_AJUSTES_DE_ESTOQUE',

  // Vendas
  VENDAS_PEDIDOS: 'VENDAS_PEDIDOS',
  VENDAS_PLANOGRAMAS: 'VENDAS_PLANOGRAMAS',
  VENDAS_CUPOM: 'VENDAS_CUPOM',
  VENDAS_NOTAS_FISCAIS: 'VENDAS_NOTAS_FISCAIS',
  VENDAS_NOTAS_FISCAIS_DE_CONSUMIDOR: 'VENDAS_NOTAS_FISCAIS_DE_CONSUMIDOR',
  VENDAS_OCORRENCIAS: 'VENDAS_OCORRENCIAS',
  VENDAS_DEVOLUCOES: 'VENDAS_DEVOLUCOES',

  // Financeiro
  FINANCEIRO_CONTAS_A_RECEBER: 'FINANCEIRO_CONTAS_A_RECEBER',
  FINANCEIRO_CONTAS_A_PAGAR: 'FINANCEIRO_CONTAS_A_PAGAR',
  FINANCEIRO_EXTRATO: 'FINANCEIRO_EXTRATO',
  FINANCEIRO_PLANO_DE_CONTAS: 'FINANCEIRO_PLANO_DE_CONTAS',
  FINANCEIRO_FLUXO_DE_CAIXA: 'FINANCEIRO_FLUXO_DE_CAIXA',
  FINANCEIRO_REPASSE_COMUNIDADES: 'FINANCEIRO_REPASSE_COMUNIDADES',

  // Relatórios - Suprimentos

  // Relatórios - Vendas
  RELATORIOS_VENDAS_VENDAS: 'RELATORIOS_VENDAS_VENDAS',
  RELATORIOS_VENDAS_CURVA_ABC: 'RELATORIOS_VENDAS_CURVA_ABC',

  // Relatórios - Financeiro
  RELATORIOS_FINANCEIRO_CONTAS_A_PAGAR: 'RELATORIOS_FINANCEIRO_CONTAS_A_PAGAR',
  RELATORIOS_FINANCEIRO_CONTAS_A_RECEBER: 'RELATORIOS_FINANCEIRO_CONTAS_A_RECEBER',

  // Relatórios - Documentos Fiscais

  // Preferências
  PREFERENCIAS_DADOS_DA_EMPRESA: 'PREFERENCIAS_DADOS_DA_EMPRESA',
  PREFERENCIAS_CERTIFICADO_DIGITAL: 'PREFERENCIAS_CERTIFICADO_DIGITAL',
  PREFERENCIAS_PERMISSOES_DE_USUARIOS: 'PREFERENCIAS_PERMISSOES_DE_USUARIOS',

  // Espaço Contador
  ESPACO_CONTADOR_DASHBOARD: 'ESPACO_CONTADOR_DASHBOARD',
  ESPACO_CONTADOR_ACESSOS: 'ESPACO_CONTADOR_ACESSOS',

  // Espaço Gestor
  ESPACO_GESTOR_DASHBOARD: 'ESPACO_GESTOR_DASHBOARD',

  // Relatórios Vendas - Páginas individuais
  RELATORIOS_VENDAS_PRODUTOS_NAO_ENCONTRADOS: 'RELATORIOS_VENDAS_PRODUTOS_NAO_ENCONTRADOS',
  RELATORIOS_VENDAS_CONVERSAO_PDV: 'RELATORIOS_VENDAS_CONVERSAO_PDV',
  RELATORIOS_VENDAS_NOTA_FISCAL_CONSULTA_PRODUTO: 'RELATORIOS_VENDAS_NOTA_FISCAL_CONSULTA_PRODUTO',
  RELATORIOS_VENDAS_NOTA_FISCAL_OPERACAO: 'RELATORIOS_VENDAS_NOTA_FISCAL_OPERACAO',
  RELATORIOS_VENDAS_NOTA_FISCAL_CLIENTE: 'RELATORIOS_VENDAS_NOTA_FISCAL_CLIENTE',
  RELATORIOS_VENDAS_NOTA_FISCAL_EVOLUCAO: 'RELATORIOS_VENDAS_NOTA_FISCAL_EVOLUCAO',

  // Relatórios Suprimentos - Páginas individuais
  RELATORIOS_SUPRIMENTOS_NECESSIDADE_COMPRA: 'RELATORIOS_SUPRIMENTOS_NECESSIDADE_COMPRA',
  RELATORIOS_SUPRIMENTOS_PERDA_PRODUTO: 'RELATORIOS_SUPRIMENTOS_PERDA_PRODUTO',
  RELATORIOS_SUPRIMENTOS_QUEBRA_ACURACIDADE: 'RELATORIOS_SUPRIMENTOS_QUEBRA_ACURACIDADE',
  RELATORIOS_SUPRIMENTOS_ORDEM_DE_COMPRA: 'RELATORIOS_SUPRIMENTOS_ORDEM_DE_COMPRA',
  RELATORIOS_SUPRIMENTOS_ESTOQUE_ENTRADA_SAIDA: 'RELATORIOS_SUPRIMENTOS_ESTOQUE_ENTRADA_SAIDA',
  RELATORIOS_SUPRIMENTOS_ESTOQUE_SALDO: 'RELATORIOS_SUPRIMENTOS_ESTOQUE_SALDO',
  RELATORIOS_SUPRIMENTOS_ESTOQUE_SEM_CIRCULACAO: 'RELATORIOS_SUPRIMENTOS_ESTOQUE_SEM_CIRCULACAO',
  RELATORIOS_SUPRIMENTOS_ESTOQUE_CUSTO_MERCADORIA_VENDIDA: 'RELATORIOS_SUPRIMENTOS_ESTOQUE_CUSTO_MERCADORIA_VENDIDA',
  RELATORIOS_SUPRIMENTOS_NOTA_ENTRADA_OPERACAO: 'RELATORIOS_SUPRIMENTOS_NOTA_ENTRADA_OPERACAO',
  RELATORIOS_SUPRIMENTOS_NOTA_ENTRADA_FORNECEDOR: 'RELATORIOS_SUPRIMENTOS_NOTA_ENTRADA_FORNECEDOR',
  RELATORIOS_SUPRIMENTOS_NOTA_ENTRADA_PRODUTO: 'RELATORIOS_SUPRIMENTOS_NOTA_ENTRADA_PRODUTO',
  RELATORIOS_SUPRIMENTOS_NOTA_ENTRADA_EVOLUCAO: 'RELATORIOS_SUPRIMENTOS_NOTA_ENTRADA_EVOLUCAO',
  RELATORIOS_SUPRIMENTOS_NOTA_ENTRADA_PRODUTO_FORNECEDOR: 'RELATORIOS_SUPRIMENTOS_NOTA_ENTRADA_PRODUTO_FORNECEDOR',

  // Relatórios Financeiro - Páginas individuais
  RELATORIOS_FINANCEIRO_BALANCETE: 'RELATORIOS_FINANCEIRO_BALANCETE',
  RELATORIOS_FINANCEIRO_DRE: 'RELATORIOS_FINANCEIRO_DRE',
  RELATORIOS_FINANCEIRO_RESULTADO_PDV: 'RELATORIOS_FINANCEIRO_RESULTADO_PDV',
  RELATORIOS_FINANCEIRO_FLUXO_CAIXA: 'RELATORIOS_FINANCEIRO_FLUXO_CAIXA',
  RELATORIOS_FINANCEIRO_CAIXA_CATEGORIA: 'RELATORIOS_FINANCEIRO_CAIXA_CATEGORIA',
  RELATORIOS_FINANCEIRO_CAIXA_CLIENTE: 'RELATORIOS_FINANCEIRO_CAIXA_CLIENTE',
  RELATORIOS_FINANCEIRO_RECEBIMENTO: 'RELATORIOS_FINANCEIRO_RECEBIMENTO',
  VENDAS_PROMOCOES: 'VENDAS_PROMOCOES',
  GERENCIAR_AGENDA: 'GERENCIAR_AGENDA',
  CRM_PESQUISAS_SATISFACAO: 'CRM_PESQUISAS_SATISFACAO',
  CATALOGO_MARCAS: 'CATALOGO_MARCAS',
  CATALOGO_UNIDADES_CONVERSAO: 'CATALOGO_UNIDADES_CONVERSAO',
  CATALOGO_ATRIBUTOS: 'CATALOGO_ATRIBUTOS',
  CATALOGO_TEMPLATES_ETIQUETA: 'CATALOGO_TEMPLATES_ETIQUETA',
  CATALOGO_MARCADORES_PRODUTOS: 'CATALOGO_MARCADORES_PRODUTOS',
  SUPRIMENTOS_MARCADORES_ORDENS_COMPRA: 'SUPRIMENTOS_MARCADORES_ORDENS_COMPRA',
  SUPRIMENTOS_MARCADORES_NOTAS_ENTRADA: 'SUPRIMENTOS_MARCADORES_NOTAS_ENTRADA',
  VENDAS_MARCADORES_PEDIDOS: 'VENDAS_MARCADORES_PEDIDOS',
  VENDAS_MARCADORES_NOTAS_FISCAIS: 'VENDAS_MARCADORES_NOTAS_FISCAIS',
  SUPRIMENTOS_MARCADORES_PICKING: 'SUPRIMENTOS_MARCADORES_PICKING',
  FINANCEIRO_MARCADORES_CAIXA: 'FINANCEIRO_MARCADORES_CAIXA',
  FINANCEIRO_MARCADORES_CONTAS_PAGAR: 'FINANCEIRO_MARCADORES_CONTAS_PAGAR',
  FINANCEIRO_MARCADORES_CONTAS_RECEBER: 'FINANCEIRO_MARCADORES_CONTAS_RECEBER',
  SUPRIMENTOS_SEPARACAO: 'SUPRIMENTOS_SEPARACAO',
  SUPRIMENTOS_ABASTECIMENTO: 'SUPRIMENTOS_ABASTECIMENTO',
  SUPRIMENTOS_ABASTECIMENTO_COMBINADO: 'SUPRIMENTOS_ABASTECIMENTO_COMBINADO',
  SUPRIMENTOS_RECEBIMENTO_MERCADORIAS: 'SUPRIMENTOS_RECEBIMENTO_MERCADORIAS',
  SUPRIMENTOS_DEPOSITOS: 'SUPRIMENTOS_DEPOSITOS',
  SUPRIMENTOS_LOTES: 'SUPRIMENTOS_LOTES',
  PREFERENCIAS_BANCOS: 'PREFERENCIAS_BANCOS',
  PREFERENCIAS_CONTAS_BANCARIAS: 'PREFERENCIAS_CONTAS_BANCARIAS',
  PREFERENCIAS_CONTAS_FINANCEIRAS: 'PREFERENCIAS_CONTAS_FINANCEIRAS',
  PREFERENCIAS_FORMAS_PAGAMENTO: 'PREFERENCIAS_FORMAS_PAGAMENTO',
  PREFERENCIAS_FORMAS_RECEBIMENTO: 'PREFERENCIAS_FORMAS_RECEBIMENTO',
  PREFERENCIAS_GATEWAYS_PAGAMENTO: 'PREFERENCIAS_GATEWAYS_PAGAMENTO',
  PREFERENCIAS_EMISSAO_FISCAL: 'PREFERENCIAS_EMISSAO_FISCAL',
  PREFERENCIAS_CENARIOS_FISCAIS: 'PREFERENCIAS_CENARIOS_FISCAIS',
  PREFERENCIAS_CFOP: 'PREFERENCIAS_CFOP',
  PREFERENCIAS_CEST: 'PREFERENCIAS_CEST',
  PREFERENCIAS_NCM: 'PREFERENCIAS_NCM',
  PREFERENCIAS_NATUREZAS_OPERACAO_ENTRADA: 'PREFERENCIAS_NATUREZAS_OPERACAO_ENTRADA',
  PREFERENCIAS_NATUREZAS_OPERACAO_SAIDA: 'PREFERENCIAS_NATUREZAS_OPERACAO_SAIDA',
  PREFERENCIAS_ENVIO_ARQUIVOS: 'PREFERENCIAS_ENVIO_ARQUIVOS',
  PREFERENCIAS_INTERFACE: 'PREFERENCIAS_INTERFACE',
  PREFERENCIAS_ESTOQUE: 'PREFERENCIAS_ESTOQUE',
  PREFERENCIAS_ORDENS_COMPRA: 'PREFERENCIAS_ORDENS_COMPRA',
  PREFERENCIAS_PEDIDOS_VENDA: 'PREFERENCIAS_PEDIDOS_VENDA',
  PREFERENCIAS_SEPARACAO: 'PREFERENCIAS_SEPARACAO',
  PREFERENCIAS_PROVEDORES_COMUNICACAO: 'PREFERENCIAS_PROVEDORES_COMUNICACAO',
  PREFERENCIAS_CANAIS_COMUNICACAO: 'PREFERENCIAS_CANAIS_COMUNICACAO',
  GERENCIAR_CONVITES: 'GERENCIAR_CONVITES',
  INTEGRACOES_EVENTOS_WEBHOOK: 'INTEGRACOES_EVENTOS_WEBHOOK',
  RELATORIOS_VENDAS_POR_HORA: 'RELATORIOS_VENDAS_POR_HORA',
  DASHBOARD_FINANCEIRO_CONTAS_A_RECEBER: 'DASHBOARD_FINANCEIRO_CONTAS_A_RECEBER',
  DASHBOARD_FINANCEIRO_CONTAS_A_PAGAR: 'DASHBOARD_FINANCEIRO_CONTAS_A_PAGAR',
  DASHBOARD_FINANCEIRO_LUCRO: 'DASHBOARD_FINANCEIRO_LUCRO',
  DASHBOARD_FINANCEIRO_CRESCIMENTO: 'DASHBOARD_FINANCEIRO_CRESCIMENTO',
  DASHBOARD_FINANCEIRO_INADIMPLENCIA: 'DASHBOARD_FINANCEIRO_INADIMPLENCIA',
  DASHBOARD_OPERACIONAL_DISPONIBILIDADE_PDV: 'DASHBOARD_OPERACIONAL_DISPONIBILIDADE_PDV',
  ANALISE_DE_RISCO: 'ANALISE_DE_RISCO',
  PREFERENCIAS_REPOSICAO_AUTOMATICA: 'PREFERENCIAS_REPOSICAO_AUTOMATICA',
  PREFERENCIAS_PICKLIST_AUTOMATICA: 'PREFERENCIAS_PICKLIST_AUTOMATICA',
} as const;

export type Resource = (typeof RESOURCES)[keyof typeof RESOURCES];
